export const fade = () => {
	(($) => {
		const fadeInit = () => {
			$(".fadeUp, .fadeLeft, .fadeRight").each(function () {
				const el = $(this),
					win = $(window).scrollTop(),
					dist = el.offset().top - $(window).height();

				if (win >= dist) {
					el.addClass("show");
					setTimeout(function () {
						el.removeClass("fadeUp");
					}, 500);
				}
			});
		};

		$(".fadeText").each(function () {
			const ft = $(this);
			ft.wrapInner("<span />");
			ft.css({ opacity: 1 });
		});

		$(window).resize(() => {
			$(".fadeText").css("height", "auto");
		});

		fadeInit();
		$(document).on("facetwp-loaded", function () {
			fadeInit();
		});

		$(window).scroll(() => {
			fadeInit();
		});
	})(jQuery);
};
